import _ from "lodash";
import { useState } from "react";
import { useRouter } from "next/router";
import World from "../world";
import Gallery from "../types/Gallery";
import { MaybeAPIErr } from "../api";
import useUpload from "./useUpload";

type UpdateGalleryHook = {
    avatar: string;
    displayName: string;
    date: string;
    onChangeDisplayName: (e: React.FormEvent<HTMLInputElement>) => void;
    onChangeDate: (e: React.FormEvent<HTMLInputElement>) => void;
    onChangeAvatar: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    err: string;
    isPending: boolean;
    isAvatarPending: boolean;
}

function useUpdateGallery(world: World, gallery: Gallery): UpdateGalleryHook {
    const router = useRouter();
    const [displayName, setDisplayName] = useState(gallery.display_name);
    const [date, setDate] = useState(gallery.date);
    const [err, setErr] = useState("");
    const [isPending, setIsPending] = useState(false);
    const {url: newAvatar, onChange: onChangeAvatar, err: errAvatar, isPending: isAvatarPending} = useUpload(world);

    const onChangeDisplayName = (e: React.FormEvent<HTMLInputElement>) => {
        setDisplayName(e.currentTarget.value);
    };

    const onChangeDate = (e: React.FormEvent<HTMLInputElement>) => {
        setDate(e.currentTarget.value);
    };

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setIsPending(true);

        const patch: any = {};

        if (displayName && displayName !== gallery.display_name) {
            patch.display_name = displayName;
        }

        if (date && date !== gallery.date) {
            patch.date = date;
        }

        if (newAvatar && newAvatar !== gallery.avatar) {
            patch.avatar = newAvatar;
        }

        const err = await world.updateGallery(gallery.name, patch);

        setIsPending(false);

        if (err) {
            setErr(err.message)
            return;
        }

        router.push("/dashboard/[[...all]]", `/dashboard/galleries/${gallery.id()}`);
    };

    return {
        avatar: newAvatar || gallery.avatar,
        displayName,
        date,
        err,
        isPending: isPending || isAvatarPending,
        isAvatarPending,
        onChangeDisplayName,
        onChangeDate,
        onChangeAvatar,
        onSubmit,
    }
};

export default useUpdateGallery;
